import { useEffect, useState } from 'react';
import { useCurrentWallet } from '../../../store/userWallet';
import { walletGuideStorageKey } from '../../../utils/constants';
import { scTrack } from '../../../utils/scTrack';
import { isBrowser } from '../../../utils/trick';

const guideStatusShowTooltip = isBrowser ? localStorage.getItem(walletGuideStorageKey) === '1' : false;

export const useGuideTooltipShow = () => {
  const { isNone } = useCurrentWallet();
  const [logicShow, setLogicShow] = useState(guideStatusShowTooltip);
  const showGuideTooltip = isNone && logicShow;

  useEffect(() => {
    if (!showGuideTooltip || !isBrowser) {
      return;
    }
    // 引导弹窗只让出现一次，
    localStorage.setItem(walletGuideStorageKey, '2');
    scTrack('SpotWeb3HomePageWalletHoverExposure', {});
  }, [showGuideTooltip]);

  return {
    showGuideTooltip,
    closeTooltip: () => {
      setLogicShow(false);
    },
  };
};
